// extracted by mini-css-extract-plugin
export var categoryIcon = "_dk-5";
export var connectorContainer = "_dk-1";
export var connectorLine = "_dk-0";
export var minHeight0 = "_dk-6";
export var relativeUnitValueSelector = "_dk-2";
export var trifoldSelectorBody = "_dk-4";
export var trifoldSelectorList = "_dk-3";